/**
 * 部屋移動の際に上部に表示される部屋ラベルを作るファイル
 *
 * webglフォルダの中にあるがこのラベルはHTMLElementで作られる
 */

import configLabel from "@/config/label";

export default class RoomLabel {
  constructor() {
    this.text0 = "";
    this.text1 = "";
    this.life0 = 0;
    this.life1 = 0;
    this.dataNode = null;
  }

  // floorデータ取得
  set(data) {
    this.dataNode = data.walk_through.node;
    this.dataDoor = data.door;
    this.dataIcons = data.icons;

    this.setNode();
    this.setDoorToNode();
    this.setIconsToNode();

    // 初期値設定
    const startId = data.walk_through.start;
    for (let i = 0; i < data.walk_through.node.length; i++) {
      if (data.walk_through.node[i].node_id === startId) {
        const label = data.walk_through.node[i].room_label;
        const name = configLabel.nodes[label]
          ? configLabel.nodes[label].name
          : label;
        this.text0 = name;
      }
    }
  }

  /**
   * nodeにデータを追加
   */
  setNode() {
    for (let i = 0; i < this.dataNode.length; i++) {
      this.dataNode[i].info = [];
    }
  }

  /**
   * nodeにdoorデータを付与する
   */
  setDoorToNode() {
    for (let i = 0; i < this.dataDoor.length; i++) {
      // doorの中点を求める
      const positions = this.dataDoor[i].positions;
      let cX = 0,
        cY = 0;
      for (let j = 0; j < positions.length; j++) {
        cX += positions[j].x;
        cY += positions[j].x;
      }
      cX = cX / positions.length;
      cY = cY / positions.length;

      // 1番近いnodeを見つける
      let nearNodeIndex = -1,
        nearNodeLen = 100000;
      for (let k = 0; k < this.dataNode.length; k++) {
        const node = this.dataNode[k];
        const len = Math.sqrt(
          (node.x - cX) * (node.x - cX) + (node.y - cY) * (node.y - cY)
        );

        if (len < nearNodeLen) {
          nearNodeLen = len;
          nearNodeIndex = k;
        }
      }

      // 使用できるusageだったらnodeに情報を代入
      const name = configLabel.useDoor[this.dataDoor[i].usage]
        ? configLabel.useDoor[this.dataDoor[i].usage].name
        : null;

      if (name !== null) {
        this.dataNode[nearNodeIndex].info.push({
          name: name,
          category: "door"
        });
      }
    }
  }

  /**
   * nodeにiconsデータを付与する
   */
  setIconsToNode() {
    for (let i = 0; i < this.dataIcons.length; i++) {
      // iconsの中点を求める
      const positions = this.dataIcons[i].positions;
      let cX = 0,
        cY = 0;
      for (let j = 0; j < positions.length; j++) {
        cX += positions[j].x;
        cY += positions[j].x;
      }
      cX = cX / positions.length;
      cY = cY / positions.length;

      // 1番近いnodeを見つける
      let nearNodeIndex = -1,
        nearNodeLen = 100000;
      for (let k = 0; k < this.dataNode.length; k++) {
        const node = this.dataNode[k];
        const len = Math.sqrt(
          (node.x - cX) * (node.x - cX) + (node.y - cY) * (node.y - cY)
        );

        if (len < nearNodeLen) {
          nearNodeLen = len;
          nearNodeIndex = k;
        }
      }

      // 使用できるusageだったらnodeに情報を代入
      const name = configLabel.useIcons[this.dataIcons[i].usage]
        ? configLabel.useIcons[this.dataIcons[i].usage].name
        : null;

      if (name !== null) {
        this.dataNode[nearNodeIndex].info.push({
          name: name,
          category: "icons"
        });
      }
    }
  }

  changeLabel(nodeId) {
    let currentIndex = 0;
    for (let i = 0; i < this.dataNode.length; i++) {
      if (nodeId === this.dataNode[i].node_id) {
        currentIndex = i;
      }
    }

    const label = this.dataNode[currentIndex].room_label;
    const info = this.dataNode[currentIndex].info;

    const name = configLabel.nodes[label]
      ? configLabel.nodes[label].name
      : label;

    if (this.text0 != name) {
      this.life0 = 3 * 60;
      this.text0 = name;
    }

    if (info[0]) {
      this.life1 = 3 * 60;
      this.text1 = info[0].name;
    }
  }

  update() {
    this.life0--;
    this.life1--;
  }
}
